/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const SubmissionIntent = {
  Wait: "wait",
  Submit: "submit",
} as const;
export type SubmissionIntent = ClosedEnum<typeof SubmissionIntent>;

/** @internal */
export const SubmissionIntent$inboundSchema: z.ZodNativeEnum<
  typeof SubmissionIntent
> = z.nativeEnum(SubmissionIntent);
/** @internal */
export const SubmissionIntent$outboundSchema: z.ZodNativeEnum<
  typeof SubmissionIntent
> = SubmissionIntent$inboundSchema;
